<template>
  <div class="flex min-h-screen flex-row infuse-layout-auth">
    <div class="hidden min-h-screen flex-1 bg-login-background bg-cover bg-no-repeat lg:flex">
      <div v-if="!hideInfuseContent.includes(theme)" class="absolute top-2 left-4 w-64 pt-8 pl-8">
        <div class="h-20 w-full bg-company-logo bg-contain bg-left-top bg-no-repeat">&nbsp;</div>
      </div>

      <div v-if="!hideInfuseContent.includes(theme)" class="relative flex w-full flex-col items-center">
        <div
          v-if="!hideLoginTitle.includes(theme)"
          class="mb-32 mt-auto text-[3.75rem] font-bold leading-[4.5rem] tracking-[-0.04rem]"
        >
          <h1>
            "EV-solutions<br />
            &nbsp;to get <br />
            you infused <br />
            &nbsp;not confused"
          </h1>
        </div>

        <img v-if="theme !== 'alfen'" class="mb-0 w-auto" src="../assets/chargecable.png" alt="charger" />
      </div>
    </div>

    <div class="flex min-h-screen flex-1 flex-col p-8">
      <div class="flex flex-initial flex-col gap-4 lg:flex-row">
        <div class="h-20 w-full flex-initial bg-company-logo bg-contain bg-left-top bg-no-repeat lg:hidden">&nbsp;</div>
        <div class="flex w-full flex-initial flex-row justify-end">
          <div class="w-48 flex-initial">
            <LocaleSwitcher />
          </div>
        </div>
      </div>

      <div class="flex flex-1 items-center justify-center">
        <router-view />
      </div>
    </div>

    <InfuseNotificationGroup v-slot="{ notifications, close }" group="notify-top">
      <InfuseNotification
        v-for="(notification, i) in notifications"
        :key="`t-infuse-notification-${i}`"
        :notification="notification"
        @click="close(i)"
      />
    </InfuseNotificationGroup>

    <InfuseNotificationGroup v-slot="{ notifications, close }" group="notify-bottom" position="bottom">
      <InfuseNotification
        v-for="(notification, i) in notifications"
        :key="`b-infuse-notification-${i}`"
        :notification="notification"
        @click="close(i)"
      />
    </InfuseNotificationGroup>
  </div>
</template>

<script lang="ts" setup>
import { InfuseNotificationGroup, InfuseNotification, LocaleSwitcher } from '@infuse/ui/components';

const theme = import.meta.env.theme || 'default';

const hideInfuseContent = ['evinity', 'mijninstallatiepartner', 'mick-e', 'ecoleon', 'chargenow', 'stroompunt'];
const hideLoginTitle = ['alfen'];
</script>
